import React, { useEffect, useState } from 'react';
import { Grid, Tooltip } from "@mui/material";
import {
    BreadCrumbs,
    PageTitleWithToolTip,
    DataGrid
} from "../Common";
import Routes from '../../routes';
import { select_commonCellProps } from '../Common/DataGrid/utils';
import { getRangeFilterOperator } from '../Common/DataGrid/FilterComponents';

const rangeFilterOperator = getRangeFilterOperator({});

const columns = [
    {
        field: 'materialType',
        headerName: 'Material Type',
        ...select_commonCellProps,
    },
    {
        field: 'refrigerantType',
        headerName: 'Refrigerant Type',
        ...select_commonCellProps,
        valueFormatter: (value) => value ?? 'N/A',
    },
    {
        field: 'class',
        headerName: 'Material Class',
        ...select_commonCellProps,
        valueFormatter: (value) => value ?? 'N/A',
    },
    {
        field: 'aR4100GWP',
        headerName: 'GWP₁₀₀ (AR4)',
        valueGetter: (value) => value,
        valueFormatter: (value) => value ?? 'N/A',
        filterOperators: rangeFilterOperator,
        flex: 1,
        renderHeader: (params) => (
          <Tooltip title="GWP over 100 years (IPCC AR4)">
            <div className="MuiDataGrid-columnHeaderTitle" data-mui-internal-clone-element="true">
              {params.colDef.headerName}
            </div>
          </Tooltip>
        ),
          
    },
    {
        field: 'aR5100GWP',
        headerName: 'GWP₁₀₀ (AR5)',
        valueGetter: (value) => value,
        valueFormatter: (value) => value ?? 'N/A',
        filterOperators: rangeFilterOperator,
        flex: 1,
        renderHeader: (params) => (
            <Tooltip title="GWP over 100 years (IPCC AR5)">
              <div className="MuiDataGrid-columnHeaderTitle" data-mui-internal-clone-element="true">
                {params.colDef.headerName}
              </div>
            </Tooltip>
          ),
    },
    {
        field: 'aR620GWP',
        headerName: 'GWP₂₀ (AR6)',
        valueGetter: (value) => value,
        valueFormatter: (value) => value ?? 'N/A',
        filterOperators: rangeFilterOperator,
        flex: 1,
        renderHeader: (params) => (
            <Tooltip title="GWP over 20 years (IPCC AR6)">
              <div className="MuiDataGrid-columnHeaderTitle" data-mui-internal-clone-element="true">
                {params.colDef.headerName}
              </div>
            </Tooltip>
          ),
    },
];

const ViewMaterialTypes = () => {
    const [filterOptions, setFilterOptions] = useState([]);

    useEffect(() => {
        const fetchFilter = async () => {
            const response = await fetch(Routes.MaterialTypes.ViewMaterialTypeFilter());
            const data = await response.json();
            setFilterOptions(data);
        }

        fetchFilter();
    }, [])

    return (
        <>
            <BreadCrumbs
                path={[
                    { text: 'Account Details', to: `/Account` },
                    { text: 'View Material Types' }
                ]}
            />
            <Grid
                container
                direction="row"
                alignItems="center"
            >
                <Grid item xs={6} md={6} lg={6} mb={2}>
                    <PageTitleWithToolTip
                        pageTitle="View Material Types"
                        toolTipText="View refrigerant material types used in assets across your account, along with Global Warming Potential (GWP) values sourced from IPCC guidance."
                    />
                </Grid>
            </Grid>
            <DataGrid
                showColumnHeaderFilter
                filterOptions={filterOptions}
                url={Routes.MaterialTypes.ViewMaterialType()}
                exportButtonURL={Routes.MaterialTypes.ExportViewMaterialType()}
                exportButtonAlt="Export Material types (.csv)"
                noResultText="Oops... It's empty here..."
                tableId={'view-material-types'}
                columns={columns}
                getRowId={(row) => row.id}
            />
        </>
    );
}

export default ViewMaterialTypes;